import { Injectable, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScrollService implements OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    ScrollEvent: Subject<number> = new Subject<number>();

    constructor() {
        this.ScrollEvent = new Subject<number>();
    }

    ngOnDestroy() {
        this.ScrollEvent.complete();
    }

    // #region Trigger Scroll

    TriggerScroll(amt?: number) {
        this.ScrollEvent.next(amt || 0);
    }

    // #endregion
}
